import {Component, OnInit, Output, EventEmitter, Input, ViewChild, ElementRef} from '@angular/core';
import {TrelloCheckItem} from '../../../trello-misc/data/trello-check-item';
import {InputNumber} from 'primeng/inputnumber';
import {SelectItem} from 'primeng/api';
import {timer} from 'rxjs';

@Component({
  selector: 'app-punch-item-tags',
  templateUrl: './punch-item-tags.component.html',
  styleUrls: ['./punch-item-tags.component.scss']
})
export class PunchItemTagsComponent implements OnInit {
  selectedTags: any[] = [];

  @Output()
  tagChangedEmitter = new EventEmitter<SelectItem[]>();

  @Input()
  tags: SelectItem[] = [];

  @Input()
  checkItem: TrelloCheckItem;

  showInput: boolean;

  inputAmount = 0;

  @ViewChild('tagAmount', {static: false})
  tagAmount: InputNumber;

  lastClicked: any;

  safetyItem: SelectItem;

  constructor() {
  }

  ngOnInit() {
    if (this.checkItem && this.checkItem.tags) {
      this.checkItem.tags.forEach(tag => {
        this.tags.forEach(tag2 => {
          if (tag2.value.name === tag.type.name) {
            if (tag.type.name === 'Amount') {
              this.showInput = true;
              this.checkItem.changeOrderAmount = tag.amount
              this.safetyItem = tag2;
            }

            this.selectedTags.push(tag2)
            return;
          }
        })
      });

      this.checkItem.tagTypes = this.selectedTags.map(tagg => tagg.value.name);
    }
  }

  tagChanged(event) {
    this.tagChangedEmitter.emit(this.selectedTags);

    if (this.lastClicked?.value?.name === 'Amount') {
      this.showInput = !this.showInput;

      if (this.showInput) {
        timer(1).subscribe(emit => {
          const tempInput = this.tagAmount.input.nativeElement as HTMLInputElement;
          if (tempInput) {
            tempInput.focus()
            tempInput.setSelectionRange(0, this.checkItem.changeOrderAmount);
          }
        })
      }
    }

  }

  optionClicked(event) {
    this.lastClicked = event.option;
  }

  onInputClick(event) {
    event.stopPropagation()
  }
}
